import { render } from "./DicomDevicesList.vue?vue&type=template&id=592264bd&scoped=true&ts=true"
import script from "./DicomDevicesList.vue?vue&type=script&lang=ts"
export * from "./DicomDevicesList.vue?vue&type=script&lang=ts"

import "./DicomDevicesList.vue?vue&type=style&index=0&id=592264bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592264bd"]])

export default __exports__